var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-ajax-bar',{ref:"bar",attrs:{"position":"bottom","color":"primary","size":"10px","skip-hijack":""}})}
var staticRenderFns = []

export { render, staticRenderFns }